<template>
  <div class="domino-game" :class="{ 'open-result': openResult }">
    <domino-card
      v-if="
          drawResult.b1_result &&
          drawResult.b2_result &&
          drawResult.p1_result &&
          drawResult.p2_result
      "
      :game="game"
      :game-data="gameData"
      :disallow-betting="disallowBetting"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :showDrawingAnimation="showDrawingAnimation"
      :draw-result="drawResult"
      @on-animation-end="onAnimationEnd"
      @show-result="showResult"
    />
    <domino-result
      :game="game"
      :game-data="gameData"
      :disallow-betting="disallowBetting"
      :minutes-string="minutesString"
      :seconds-string="secondsString"
      :win-cell-no="obj.getResultPB_sum"
      @show-result="showResult"
    />
    <div class="domino-player-banker">
      <domino-player
        :game="game"
        :game-data="gameData"
        :disallow-betting="disallowBetting"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :win-numbers="[
          obj.getResultP_bs,
          obj.getResultP_oe
        ]"
      />
      <domino-banker
        :game="game"
        :game-data="gameData"
        :disallow-betting="disallowBetting"
        :minutes-string="minutesString"
        :seconds-string="secondsString"
        :win-numbers="[
          obj.getResultB_bs,
          obj.getResultB_oe
        ]"
      />
    </div>

    <div
      ref="domino-disallow-betting-section"
      class="domino-disallow-betting-section"
      v-if="displayDisallowSection"
    >
      <Row class="domino-disallow-betting" type="flex" justify="center" align="middle">
        <Col>
          <div>{{ $t("general.no_more_bet") }}</div>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
import { snakeCase } from "change-case";
import { random } from "lodash";
import { TweenLite, TimelineLite } from "gsap";
import { Row, Button, Timeline } from "iview";

import DominoCard from "./domino-game/DominoCard";
import DominoResult from "./domino-game/DominoResult";
import DominoPlayer from "./domino-game/DominoPlayer";
import DominoBanker from "./domino-game/DominoBanker";

import EventBus from "../../configs/event-bus";

let testarr = [];
const plateTl = new TimelineLite();
const diceTl = new TimelineLite();

export default {
  props: [
    "game",
    "gameData",
    "countDown",
    "drawResult",
    "showDrawingAnimation",
    "disallowBetting",
    "displayDisallowSection",
    "minutesString",
    "secondsString",
    "onAnimationEnd"
  ],
  components: {
    DominoCard,
    DominoResult,
    DominoPlayer,
    DominoBanker,
    Row,
    Button
  },
  computed: {
    snakeCaseTitle() {
      return snakeCase(this.game);
    }
  },
  data() {
    return {
      openResult: false,
      testing: 0,
      firstp1: 0,
      firstp2: 0,
      getResultP_bs: 0,
      getResultP_oe: 0,
      getResultB_bs: 0,
      getResultB_oe: 0,
      getResultPB_sum: 0,
      P_Sum: 0,
      B_Sum: 0,
      obj: 0,
      counter: 0
    };
  },
  watch: {
    showDrawingAnimation(newVal, oldVal) {
      let vm = this;
      if (newVal) {
        this.showResult(); //for highlight the draw result when flip the card
      }
      setTimeout(() => {
        this.openResult = false;
      }, 6000);
    },

    drawResult() {
      // console.log("ClearDominoStake");
      // clearStakeRecord(this.gameData.gID);
      // EventBus.$emit("update-session-storage");
    }
  },
  mounted() {
    this.getPrevResult();
    EventBus.$emit("update-session-storage");
  },
  methods: {
    getPrevResult: function getPrevResult() {
      this.obj = {
        getResultPB_sum: "o" + this.gameData.prev.pb,
        getResultP_bs: "o" + this.gameData.prev.spbs,
        getResultP_oe: "o" + this.gameData.prev.spoe,
        getResultB_bs: "o" + this.gameData.prev.sbbs,
        getResultB_oe: "o" + this.gameData.prev.sboe
      };
      return this.obj;
    },
    showResult: function showResult(getResult) {
      clearTimeout(this.delayResultTimer);
      clearInterval(this.drawResultTimer);
      this.openResult = true;

      this.obj = 0;
      if (getResult != null) {
        if (this.counter < 3) {
          if (this.counter == 0 || this.counter == 2) {
            //Player Sum
            if (getResult < 5) {
              this.getResultP_bs = "5";
            } else if (getResult > 4) {
              this.getResultP_bs = "4";
            }
            if (getResult % 2 != 0) {
              this.getResultP_oe = "6";
            } else if (getResult % 2 == 0) {
              this.getResultP_oe = "7";
            }

            this.P_Sum += getResult;
            this.P_Sum %= 10;
          } else if (this.counter == 1 || this.counter == 3) {
            //Banker Sum
            if (getResult < 5) {
              this.getResultB_bs = "9";
            } else if (getResult > 4) {
              this.getResultB_bs = "8";
            }
            if (getResult % 2 != 0) {
              this.getResultB_oe = "10";
            } else if (getResult % 2 == 0) {
              this.getResultB_oe = "11";
            }

            this.B_Sum += getResult;
            this.B_Sum %= 10;
          }
          //Result Player & Banker
          if (this.P_Sum > this.B_Sum) {
            this.getResultPB_sum = "1";
          } else if (this.P_Sum == this.B_Sum) {
            this.getResultPB_sum = "2";
          } else if (this.P_Sum < this.B_Sum) {
            this.getResultPB_sum = "3";
          }
          this.counter++;
        } else {
          this.counter = 0;
          //retrive real draw result
          this.getResultPB_sum = this.drawResult.pb;
          this.getResultP_bs = this.drawResult.spbs;
          this.getResultP_oe = this.drawResult.spoe;
          this.getResultB_bs = this.drawResult.sbbs;
          this.getResultB_oe = this.drawResult.sboe;
        }
        this.obj = {
          getResultPB_sum: "o" + this.getResultPB_sum,
          getResultP_bs: "o" + this.getResultP_bs,
          getResultP_oe: "o" + this.getResultP_oe,
          getResultB_bs: "o" + this.getResultB_bs,
          getResultB_oe: "o" + this.getResultB_oe
        };
        return this.obj;
      } else {
        this.P_Sum = 0;
        this.B_Sum = 0;
        this.counter = 0;

        this.obj = 0;
        return this.obj;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.domino-game {
  position: relative;
  height: 373px;
}
.domino-player-banker {
  display: flex;
  padding-bottom: 5px;
  background: #e5eaf8;
}
.domino-main-bet {
  display: flex;
  height: 178px;
  background-color: black;
}
.domino-no-bet {
  background-color: black;
}

.domino-animation-section {
  display: none;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.domino-animation-section.hide {
  display: none;
}

.domino-disallow-betting-section {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
}

.domino-stop-animation-section {
  position: absolute;
  display: none;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  color: white;
  background: rgba(#000000, 0.9);
  font-size: 16px;
}

.domino-stop-animation-section.show {
  display: block;
}

.domino-disallow-betting,
.domino-stop-animation {
  width: 100%;
  height: 100%;
}

.domino-animation-container {
  height: 100%;
  width: 100%;
  background: rgba(#000000, 0.9);
}

.domino-animation-result {
  display: none;
  width: 100%;
  height: 100%;
}

.domino-animation-result .domino-animation-result-plate {
  width: 100%;
  height: auto;
  z-index: 99;
}

.domino-animation-result-container,
.domino-animation-banner-container {
  position: relative;
}

.domino-animation-result-container {
  z-index: 2;
}

.domino-animation-banner-container {
  display: none;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  padding: 0 20px;
  z-index: 1;
}

.domino-animation-result-dice {
  display: none;
  width: 15%;
  position: absolute;
  top: 0;
  z-index: 100;
  border-radius: 6px;
  box-shadow: 0 0 4px 2px #00000044;
}

.domino-animation-result-banner-top,
.domino-animation-result-banner-sum {
  width: 85%;
  position: absolute;
  top: 25%;
}

.domino-animation-result-banner-sum {
  top: 27%;
}

.domino-animation-result-banner-sum-total {
  font-size: 24px;
  color: $tai-xiu-theme-color-6;
  font-weight: bold;
  font-size: 36px;
  line-height: 1;
}

.domino-animation-result-banner-sum-title {
  color: white;
  font-weight: bold;
}

.domino-animation-result-banner-bottom,
.domino-animation-result-banner-game {
  width: 85%;
  position: absolute;
  bottom: 25%;
}

.domino-animation-result-banner-game {
  bottom: 30%;
}

.domino-animation-result-banner-game-result {
  padding: 5px;
  background-color: white;
  color: $tai-xiu-theme-color-3;
  font-weight: bold;
  width: 60px;
  margin: 0 5px;
  border-radius: 8px;
  text-align: center;
}

.domino-game-animation-next-draw {
  background-color: $tai-xiu-theme-color-13;
  color: $tai-xiu-theme-color-5;
  border-radius: 6px;
  font-size: 14px;
  margin-right: 5px;
  padding: 4px 20px;
  font-weight: bolder;
  z-index: 1;
}

.domino-game-animation-next-draw-section {
  position: absolute;
  top: 20px;
  width: 100%;
}

.domino-animation-inner {
  position: relative;
  width: 100%;
}

.domino-animation-banner-inner {
  height: 100%;
}

@media only screen and (max-width: 360px) {
  .domino-animation-result-banner-sum {
    top: 26%;
  }

  .domino-animation-result-banner-game {
    bottom: 29%;
  }
}
</style>
